import React from 'react'
import { Checkbox, Form } from 'antd'

const SITE_URL = 'https://horsesmart.store'

// Владелец магазина — Партнёр площадки; сотрудник заводит обычный аккаунт
// Пользователя, поэтому соглашается на условиях покупателя
const CONSENT_URLS = {
  seller: `${SITE_URL}/consent-seller-pd`,
  buyer: `${SITE_URL}/consent-buyer-pd`
}

const REQUIRED_MESSAGE = 'Необходимо согласие на обработку персональных данных'

interface IPersonalDataConsentProps {
  subject: keyof typeof CONSENT_URLS
}

export const PersonalDataConsent: React.FC<IPersonalDataConsentProps> = ({
  subject
}) => (
  <Form.Item
    name='personal_data_consent'
    valuePropName='checked'
    rules={[
      {
        validator: (_, value) =>
          value ? Promise.resolve() : Promise.reject(new Error(REQUIRED_MESSAGE))
      }
    ]}
  >
    <Checkbox>
      Я даю{' '}
      <a href={CONSENT_URLS[subject]} target='_blank' rel='noreferrer'>
        согласие на обработку моих персональных данных
      </a>{' '}
      на условиях{' '}
      <a href={`${SITE_URL}/privacy-policy`} target='_blank' rel='noreferrer'>
        Политики конфиденциальности
      </a>
    </Checkbox>
  </Form.Item>
)
